import { Checkbox } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/pages/cdp/filters.module.scss";

import { Conditions, ModifierTypes } from "../Filters";

import classNames from "classnames/bind";
import DateForm from "../types/DateForm";
const css = classNames.bind(styles);

export const BirthdayForm = ({ data, variable, onChange }) => {
  const [collapsed, setCollapsed] = useState(false);
  const operands = Object.keys(ModifierTypes).filter(
    (k) => k === "in_last" || k === "month" || k === "bt" || k === 'in_next'
  );

  const freshData = {
    name: variable.label,
    type: "c.birthdate",
    operand: data?.operand || "in_last",
    active: data?.active || false,
    values: data?.values || null,
    value_type: data?.value_type || "day",
  };

  const input_configs = {
    mask: "99/99",
    placeholder: "DD/MM",
    format: "DD/MM",
  };

  useEffect(() => {
    if (freshData.active) setCollapsed(true);
  }, [freshData.active]);

  return (
    <li className={css({ filter: true, collapsed })} key={variable.label}>
      <div
        className={styles.header}
        onClick={() =>
          !freshData.active && onChange({ ...freshData, active: true })
        }
      >
        <div className="d-flex align-center">
          <Checkbox
            design="two"
            label={variable.label}
            checked={freshData?.active}
            onChange={(value) => onChange({ ...freshData, active: value })}
          />
          {freshData?.active && <div className={styles.dot} />}
        </div>
        <div className="d-flex align-center">
          {operands.length > 1 && collapsed && (
            <>
              <Conditions
                types={operands}
                condition={freshData?.operand}
                onChange={(condition) =>
                  onChange({
                    ...freshData,
                    operand: condition,
                  })
                }
              />
              <div className={styles.divisor} />
            </>
          )}

          <div
            className={styles.collapse}
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? (
              <i className="fas fa-minus" />
            ) : (
              <i className="fas fa-plus" />
            )}
          </div>
        </div>
      </div>

      {collapsed && (
        <div className={styles.content}>
          <DateForm
            data={freshData}
            input_configs={input_configs}
            onChange={(newData) => {
              onChange({ ...data, ...newData });
            }}
          />
        </div>
      )}
    </li>
  );
};
